<template>
  <div class="common-container__body" style="border: none;">
    <SpinnerLoadingModal v-if="isLoading" />
    <p v-else-if="errorLoadEntity">
      Ошибка: невозможно отобразить информацию.
    </p>

    <form class="pacs-entity-form-primary" @keyup.enter="saveDataAnalytics()" @submit.prevent="saveDataAnalytics()">
      <br>

      <div class="buttons-group">

        <CamsButton
          title="Открыть плеер для просмотра и редактирования зон аналитики"
          type="button"
          @click="openDialogEditParkingStops()"
        >
           Зона распознавания
        </CamsButton>
      </div>
    </form>
  </div>
</template>

<script>
import {editEntityMixin} from "@/components/pacs/mixins.js";
import {
  ACTION_EDIT_PARKING_DETECTION_ANALYTICS,
  ACTION_LOAD_PARKING_DETECTION_ANALYTICS_FOR_EDIT, CAMERA_PARKING_ANALYTICS_STRUCT,
} from "@/store/analytics/index.js";
import {ACTION_LOAD_CAMERA_FOR_EDIT_ANALYTICS, FIELDS_CAMERA} from "@/store/cameras/index.js";
import {TOKEN_TTL} from "@/utils/consts.js";
import {
  AnalyticParkingStop,
  AnalyticParkingStopsConfig,
} from "camsng-frontend-shared/components/smartPlayer/mixins.js";
import RequestTokenCameraDialog from "@/components/pacs/analytics/RequestTokenCameraDialog.vue";

export default {
  name: "EditParkingStopsAnalytics",
  mixins: [editEntityMixin],
  data() {
    const cameraNumber = this.$route.params.cameraNumber;

    return {
      entityId: cameraNumber,
      actionForLoadEntity: `analytics/${ACTION_LOAD_PARKING_DETECTION_ANALYTICS_FOR_EDIT}`,
      actionForSave: `analytics/${ACTION_EDIT_PARKING_DETECTION_ANALYTICS}`,
      numbers: [],
    };
  },
  methods: {
    /**
     * Загрузка информации по конкретной камере.
     */
    async afterLoadSourceData() {
      this.dataForm = {
        cameraNumber: this.sourceData.entityInfo[CAMERA_PARKING_ANALYTICS_STRUCT.fields.camera_number.name],
        parkingSpots: this.sourceData.entityInfo[CAMERA_PARKING_ANALYTICS_STRUCT.fields.parking_spots.name],
        imageWidth: this.sourceData.entityInfo[CAMERA_PARKING_ANALYTICS_STRUCT.fields.image_width.name],
        imageHeight: this.sourceData.entityInfo[CAMERA_PARKING_ANALYTICS_STRUCT.fields.image_height.name],
      };
    },
    /**
     * Сохранение данных и продолжение редактирования.
     * После успешного сохранения данных происходит перезагрузка исходных данных.
     */
    async saveDataAnalytics() {
      try {
        await this.saveData();
        await this.loadSourceData();
        this.$notify({
          group: "main",
          text: this.$t('saveSuccess'),
          duration: 5000,
          type: "success"
        });
      } catch {
        this.$notify({
          group: "main",
          text: this.$t('errorOccurred'),
          duration: 5000,
          type: "error"
        });
      }
    },
    /**
     * Открытие формы для редактирования зон аналитики.
     */
    async openDialogEditParkingStops() {
      const response = await this.$store.dispatch(`cameras/${ACTION_LOAD_CAMERA_FOR_EDIT_ANALYTICS}`, {
        fields: [
          FIELDS_CAMERA.number,
          FIELDS_CAMERA.address,
          FIELDS_CAMERA.title,
          FIELDS_CAMERA.is_embed,
          FIELDS_CAMERA.analytics,
          FIELDS_CAMERA.is_fav,
          FIELDS_CAMERA.is_public,
          FIELDS_CAMERA.server,
          FIELDS_CAMERA.streams_count,
          FIELDS_CAMERA.token_l,
          FIELDS_CAMERA.token_r,
          FIELDS_CAMERA.token_d,
          FIELDS_CAMERA.permission,
        ],
        tokenDVRTTL: TOKEN_TTL.MULTI,
        tokenDownloadStart: 1,
        numbers: [this.entityId],
      });
      const cameraInfo = response.data.results[0];
      const spotsFromBackend = this.dataForm.parkingSpots || []; // [{id, coordinates:[[x,y]...]}]
      const analyticParkingStopsConfigForEdit = new AnalyticParkingStopsConfig(
        this.dataForm.imageWidth,
        this.dataForm.imageHeight,
        4,
        4,
        spotsFromBackend.map(s =>
          new AnalyticParkingStop(
            s.coordinates,
            1,
            s.id
          )
        )
      );
      console.log(analyticParkingStopsConfigForEdit)
      this.$camsdals.open(
        RequestTokenCameraDialog,
        {
          archiveToken: cameraInfo.token_r,
          downloadToken: cameraInfo.token_d,
          liveToken: cameraInfo.token_l,
          cameraNumber: this.entityId,
          title: cameraInfo.title,
          domain: cameraInfo.server.domain,
          streamCount: cameraInfo.streams_count,
          hasSound: cameraInfo.is_sounding,
          vendorName: cameraInfo.server.vendor_name,
          analyticParkingStopsConfig: analyticParkingStopsConfigForEdit,
        },
        {dialogTitle: `Просмотр видео с камеры №${this.entityId} - ${cameraInfo.title}`},
        {
          name: "js-click-outside",
          size: "lg",
          onClose: async (analyticParkingStopsConfigForSave) => {
            if (!analyticParkingStopsConfigForSave) return;

            this.dataForm.imageWidth = analyticParkingStopsConfigForSave.zonesWidthParking;
            this.dataForm.imageHeight = analyticParkingStopsConfigForSave.zonesHeightParking;

            this.dataForm.parkingSpots = analyticParkingStopsConfigForSave.exportParkingStops().map(z => ({
              id: z.id,
              coordinates: z.exportCoordsPairs(),
            }));
            console.log(this.dataForm)
            await this.saveData();
          }
        }
      );
    },
  },
};
</script>
